'use strict';

var time2string = function time2string(value) {
	if (value == null || typeof value == 'undefined') {
		return '';
	}
	var hours = Math.floor(value / 60);
	var mins = value - hours * 60;
	return hours + ':' + (mins < 10 ? '0' : '') + Math.round(mins);
};

var string2time = function string2time(value) {
	if (value == null || typeof value == 'undefined') {
		return null;
	}
	var arr = value.split(':');
	var hours = parseInt(arr[0]);
	var mins = arr[1] ? parseInt(arr[1]) : 0;
	return hours * 60 + mins;
};

exports.string2time = string2time;
exports.time2string = time2string;


/*****************
 ** WEBPACK FOOTER
 ** ./src/helpers/time.js
 ** module id = 1002
 ** module chunks = 2
 **/